<template>
  <div
    id="instant-match-filter"
    v-if="instantMatchToggleEnabled"
    class="filter-wrapper instant-match px-3 py-2 d-flex align-items-center justify-content-between br-4"
  >
    <div class="d-flex align-items-center mr-2 font-small font-weight-bold flex-grow-1 no-select">
      <span>
        <inline-svg
          class="sunrise-text-gradient"
          height="20"
          width="20"
          style="margin-bottom: 3px; margin-right: 2px"
          :src="require('@/assets/icons/fnd/fire.svg')"
        />
        Best Matches
      </span>
    </div>
    <b-form-checkbox
      v-model="instantMatch"
      name="instant-match"
      switch
      style="margin-bottom: 2px"
      @change="instantChatOnChange"
    />
    <!-- Tooltip -->
    <b-tooltip target="instant-match-filter" triggers="hover">
      <div class="white--txt py-2">
        <span class="d-inline-block lead white--txt">Recommended Homes</span>
      </div>
      <p class="py-2 font-small white--txt mb-0">
        These are the homes that are looking for a roommate like you based on your profile.
      </p>
    </b-tooltip>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'InstantMatchesFilter',
  data() {
    const { instantMatch } = this.$route.query
    return {
      instantMatch: [true, 'true'].includes(instantMatch),
    }
  },
  computed: {
    ...mapGetters('user', ['userProfileMatchReady']),
    // toggle is only available for co-living properties
    // ensure the user's profile is compatible with match
    instantMatchToggleEnabled() {
      const { offering } = this.$route.params
      return offering === 'rooms-for-rent' && this.userProfileMatchReady
    },
  },
  watch: {
    '$route.query'(val) {
      if (this.instantMatchToggleEnabled && !('instantMatch' in val)) this.instantMatch = false
    },
  },
  methods: {
    instantChatOnChange(instantMatch) {
      this.$segment.track('Roommate Match Toggle Updated', {
        Type: instantMatch ? 'Enabled' : 'Disabled',
      })
      const { query } = this.$route
      this.$router.replace({ query: { ...query, instantMatch } }).catch(() => {})
    },
  },
}
</script>

<style lang="scss" scoped>
.instant-match {
  border: 1px solid $charcoal-10;
  background-color: rgba(242, 241, 241, 0.5);
  height: 48px;
  img {
    height: 15px;
    width: 15px;
  }
}
</style>
